<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm12 md6>
          <v-card class="mx-auto pa-5" color="#26c6da" dark height="450">
            <v-layout column>
              <v-flex xs12 class="mb-3">
                <div class="display-2 text-xs-center">H A L</div>
                <div class="headline text-xs-center">HABIB ASSOCIATES LTD.</div>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  placeholder="Mobile No"
                  outline
                  single-line
                  v-model="login.phone"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  placeholder="Password"
                  outline
                  type="password"
                  single-line
                  v-model="login.password"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-btn
                  block
                  round
                  dark
                  outline
                  @click="loginDo"
                  :disabled="actionButtonClicked"
                  :loading="actionButtonClicked"
                  >Login Me</v-btn
                >
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import router from "../router";
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      dialogm1: "",
      dialog: false,
      login: {
        phone: "",
        password: "",
      },
      actionButtonClicked: false
    };
  },
  computed: {
    ...mapGetters("common", {
      logged: "logged",
    }),
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
      this.clearForm();
    },
    clearForm() {
      this.login = {
        phone: "",
        password: "",
      };
    },
    onCreateUserClicked() {
      this.$emit("create");
    },
    loginDo() {
      this.actionButtonClicked = true;
      this.post("/auth", this.login).then((res) => {
        if (res.data.success) {
          this.$store.commit("common/setLogged", res.data.data);
          this.$user = this.logged.user;
          // this.onCancelled();

          router.push("/");
        }
        this.snackbarShow(res.data);
        this.actionButtonClicked = false;
      });
    },
  },
};
</script>

<style scoped>
.company-menu-container .menu-a {
  color: white;
  text-decoration: none;
}
.service-table {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  padding: 0;
  margin: 0;
}
.service-table th {
  border: thin solid #969696;
  margin: 0;
  background-color: #bfbfbf;
  padding: 5px;
  font-size: 20px;
}
.service-table td {
  border: thin solid black;
  padding: 10px;
  font-size: 19px;
}
.category-row {
}
</style>
